import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Text from './Text';
import TextArea from './TextArea';

export const ContactForm = props => {
  const { handleSubmit, pristine, reset, submitting } = props;

  return (
    <form id="contactForm" name="contactForm" onSubmit={handleSubmit}>
      <fieldset>
        <Field name="name" label="Name" component={Text} />
        <Field name="email" label="Email" component={Text} />
        <Field name="message" label="Message" component={TextArea} />

        <div>
          <button className="submit">Submit</button>
          <span id="image-loader">
            <img alt src="images/loader.gif" />
          </span>
        </div>
      </fieldset>
    </form>
  )
};

export default reduxForm({ form: 'contactForm', onSubmit: values => values })(ContactForm);




// WEBPACK FOOTER //
// ./src/components/Contact/ContactForm.js